import { useEffect } from 'react';
/**
 * Used to support closing the drawer on escape keypress.
 */
export function useInlineDrawerKeydown({ isOpen, onClose, closeOnEsc, }) {
    const onKeyDown = (event) => {
        if (event.key === 'Escape' && closeOnEsc) {
            onClose();
        }
    };
    useEffect(() => {
        if (isOpen) {
            document.addEventListener('keydown', onKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [isOpen, closeOnEsc, onClose]);
}
//# sourceMappingURL=useDrawerKeyDown.js.map